import React, { useEffect, useState } from "react";
import NavigationBar from "../components/ui/Navbar";
import { useNavigate } from "react-router-dom";
import CreateEventModal from "../components/modals/CreateEventModal";
import { UserAuth } from "../lib/authContext";
import { authEmails } from "../lib/constants";

const Dashboard = () => {
  const navigate = useNavigate();
  const { userData, events, getAllEvents } = UserAuth();

  const [modalVisible, setModalVisible] = useState(false);

  useEffect(() => {
    getAllEvents();
  }, []);

  return (
    <div className="flex flex-col items-center">
      <NavigationBar />
      <div
        id="dashboard"
        className="flex flex-col min-h-screen py-28 px-3 container"
      >
        {events && events.length > 0 ? (
          <div className="flex flex-col">
            {userData?.email && authEmails.includes(userData.email) && (
              <button
                className="flex items-center self-center select-none text-black bg-gradient-to-b from-[#fce96a] to-[#e3a008] rounded-md focus:outline-none hover:from-yellow-500 hover:to-yellow-400 px-5 py-3 mb-5"
                onClick={() => setModalVisible(true)}
              >
                <p>Create a new event</p>
              </button>
            )}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 xl:gap-10">
              {events.map((event) => (
                <div
                  key={event.event_id}
                  className="flex flex-row p-3 bg-[#A18DA31A] border border-[#5a495b80] rounded-lg cursor-pointer hover:opacity-90 w-full"
                  onClick={() => navigate(`/events/${event.event_id}`)}
                >
                  <img
                    src={event.cover_image}
                    alt={event.event_name}
                    className="h-40 w-40 object-contain mr-3"
                  />
                  <div className="flex flex-col justify-center">
                    <p className="font-medium text-xl">{event.event_name}</p>
                    <i className="text-sm">{event.event_description}</i>
                    <p className="text-sm mt-1">
                      {new Date(event.start_date).toDateString()}
                      {" - "}
                      {new Date(event.end_date).toDateString()}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <p className="ml-1">Loading Events...</p>
        )}
      </div>

      <CreateEventModal
        modalIsOpen={modalVisible}
        closeModal={() => setModalVisible(false)}
      />
    </div>
  );
};

export default Dashboard;
